export const DISCOUNT_HISTORY_COLUMNS = {
  direction: 'direction',
  end: 'end',
  energyType: 'energyType',
  name: 'name',
  start: 'start',
  status: 'status'
}
export type DiscountHistoryColumnKeys = (typeof DISCOUNT_HISTORY_COLUMNS)[keyof typeof DISCOUNT_HISTORY_COLUMNS]
